import React from 'react'
import { formatPrice } from '@aytm/app/swidget/base/questions/Ecommerce/utils/formatPrice.ts'
import useSurveyLocale from '../../../modules/locale/useSurveyLocale.ts'
import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink.tsx'
import style from '@aytm/app/swidget/base/questions/Ecommerce/Amazon/amazon.module.scss'

interface CartPriceColumnProps {
  price: number
  priceMask: string
  answer: {
    subscribe_percent?: number
    subscribe_coupon_percent?: number
  }
  subscribe?: number
}

const CartPriceColumn = ({ price, priceMask, answer, subscribe }: CartPriceColumnProps) => {
  const { t } = useSurveyLocale()

  return (
    <>
      <div className={style.priceBlock}>
        <span
          dangerouslySetInnerHTML={{
            __html: formatPrice(price, priceMask, true, true)
          }}
        ></span>
      </div>
      {subscribe && answer.subscribe_percent && (
        <>
          {answer.subscribe_coupon_percent && (
            <div className={style.cartSubscribeBlock}>
              <div className={style.cartCouponClipped}>
                <span className={style.cartCouponBadge}>{t('questions', 'ec', 'amazon', 'couponClipped')}</span>
              </div>

              <div className={style.cartSubscribeRow}>
                <span className={style.cartSubscribeDiscount}>
                  {t('questions', 'ec', 'amazon', 'save')} {answer.subscribe_coupon_percent}%
                </span>
              </div>
            </div>
          )}
          <div className={style.cartSubscribeExtra}>
            <div className={style.cartSubscribeRow}>
              <span
                className={style.cartSubscribeText}
                dangerouslySetInnerHTML={{
                  __html:
                    answer.subscribe_percent +
                    '% ' +
                    t('questions', 'ec', 'amazon', 'subscribeAndSave') +
                    ' ' +
                    t('questions', 'ec', 'amazon', 'discountApplied') +
                    '.'
                }}
              />
            </div>
            <div className={style.cartDeliveryFrequency}>
              <span>{t('questions', 'ec', 'amazon', 'deliverEvery')}</span>
              <br />
              <EmptyLink>
                <span className={style.link}>
                  {t<(months: number) => string>('questions', 'ec', 'amazon', 'deliveryMonths')(subscribe)}{' '}
                </span>
              </EmptyLink>
            </div>
          </div>
        </>
      )}
      {!subscribe && answer.subscribe_percent && (
        <span className={style.cartSubscribeSaveText}>
          <EmptyLink>
            <span
              className={style.link}
              dangerouslySetInnerHTML={{
                __html: t<(percent: number) => string>(
                  'questions',
                  'ec',
                  'amazon',
                  'subscribeAndSaveCart'
                )(answer.subscribe_percent)
              }}
            />
          </EmptyLink>
        </span>
      )}
    </>
  )
}

export default CartPriceColumn
